/**
 * Where commerce is allowed to exist.
 *
 * iOS ships as a FREE COMPANION to the paid web product under App Store Review
 * Guideline 3.1.3(f): "provided there is no purchasing inside the app, or calls
 * to action for purchase outside of the app." Switzerland is our launch
 * storefront and it is the strictest regime (no US 3.1.1(a) exemption, no EU
 * DMA terms), so native carries no price, no purchase CTA and no steering.
 *
 * This is a PLATFORM property decided at build time, deliberately NOT a remote
 * flag: a switch that re-enabled purchase CTAs on an already-approved binary is
 * the hidden-feature case Guideline 2.3.1 rejects. Android follows the same rule
 * because Google Play's payments policy is the same shape.
 *
 * Every web-only commerce value goes through `ifCommerce(web, native)`. Where
 * the native side is `null` the TYPE forces the call site to handle absence, so
 * a purchase entry point cannot be rendered on native by forgetting a check.
 * `scripts/ci/check-native-commerce.ts` enforces that nothing bypasses this.
 */

import { Platform } from 'react-native';

export function isCommerceEnabled(os: string): boolean {
  return os === 'web';
}

export const COMMERCE_ENABLED: boolean = isCommerceEnabled(Platform.OS);

export function ifCommerce<W, N>(onWeb: W, elsewhere: N): W | N {
  return COMMERCE_ENABLED ? onWeb : elsewhere;
}

/** The one sentence native may say about a feature outside the user's plan. */
export const NOT_IN_PLAN = 'Not included in your current plan';
